module.exports = __webpack_public_path__ + "static/media/greenFish.619c99ab.svg";